import CustomBreadCrumbs from "design/common/customBreadCrumbs";
import "design/referenceCss/referenceHeader.css";
const HeaderBackground = (props: any) => {
  const { route } = props;
  return (
    <div className={"reference-container"}>
      <div className={"reference-header-image"}>
        <div className={"reference-header-image-navi"}>
          <CustomBreadCrumbs routes={route} />
        </div>
      </div>
    </div>
  );
};
export default HeaderBackground;
